import { MultiValue } from 'react-select';
import { useDebouncedCallback } from 'use-debounce';
import AsyncSelect from 'react-select/async';
import * as R from 'ramda';
import { RANKING_RULE_TARGET_TYPES } from '../../constants/index';
import RecommendConceptsClient from '../../clientAPI/recommendConcepts';

export default function TargetTaxonomyForm({
  validationError,
  onActionItemsChange,
}: {
  validationError: string;
  onActionItemsChange: (
    items: RankingRuleTargetBoostItem[] | RankingRuleTargetBuryItem,
  ) => void;
}) {
  const asyncOptions = useDebouncedCallback((inputValue, callback) => {
    RecommendConceptsClient.searchConcepts(inputValue)
      .then((res) => {
        const opts = res.objects.map((c) => {
          const label =
            c.name === c.alternateName
              ? `${c.name} ${c.source.system}`
              : `${c.name}(${c.alternateName}) ${c.source.system}`;
          return {
            value: {
              id: c.id,
              name: c.name,
            },
            label,
          };
        });
        callback(opts);
      })
      .catch((err: { status: number }) => {
        console.log(err);
        callback([]);
      });
  }, 1000);

  const handleSelectChange = (
    newSelectOpts: MultiValue<{ label: string; value: any }>,
  ) => {
    const selectedConcepts = R.uniqBy(
      R.prop('id'),
      newSelectOpts.map((cp) => cp.value),
    );
    const items = selectedConcepts.map((sc) => ({
      type: RANKING_RULE_TARGET_TYPES.TAXONOMY,
      value: sc.id,
      label: sc.name,
      relation: 'eq',
    }));
    onActionItemsChange(items);
  };

  return (
    <div className='tw-mb-10'>
      <div className='select-portal-target' />
      <AsyncSelect
        className='eds-select eds-text-field__input eds-text-field--select tw-mt-4'
        classNamePrefix='eds-select'
        isMulti
        cacheOptions
        loadOptions={asyncOptions}
        onChange={handleSelectChange}
        menuPosition='fixed'
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
      {validationError && <p className='tw-text-red-900'>{validationError}</p>}
    </div>
  );
}
